/**
 * Workshop booking wizard → GTM dataLayer (GA4 via GTM).
 * Theme-only; does not talk to AOGEN Connect Forms.
 *
 * Events (user actions, not step titles):
 *   wbw_wizard_view, wbw_step_view, wbw_venue_select,
 *   wbw_date_select, wbw_time_select,
 *   wbw_design_lightbox_open, wbw_design_select,
 *   wbw_add_to_cart, wbw_add_to_cart_error, wbw_abandon
 */
(function (global) {
  'use strict';
  if (global.WorkshopBookingWizardAnalytics) return;

  var engaged = false;
  var converted = false;
  var abandonBound = false;
  var abandonSent = false;
  var viewed = false;
  var had = { venue: false, date: false, time: false, design: false };
  var lastBranch = '';
  var lastStepTracked = '';

  function safeStr(v) {
    return v == null ? '' : String(v).trim();
  }

  function push(eventName, params) {
    try {
      global.dataLayer = global.dataLayer || [];
      var payload = { event: eventName };
      if (params && typeof params === 'object') {
        Object.keys(params).forEach(function (k) {
          if (params[k] == null || params[k] === '') return;
          payload[k] = params[k];
        });
      }
      global.dataLayer.push(payload);
    } catch (_) {}
  }

  function venueBits(state) {
    var v = (state && state.selectedVenue) || {};
    return {
      wbw_venue_id: safeStr(v.venue_ref_id || v.venue_id || ''),
      wbw_venue_name: safeStr(v.venue_name || v.name || state.venueDisplayLabel || ''),
      wbw_city: safeStr(v.city || ''),
      wbw_state: safeStr(v.state || ''),
    };
  }

  function slotBits(state) {
    var slot = (state && state.selectedSlot) || null;
    var raw = (slot && slot._raw) || {};
    return {
      wbw_date: safeStr((state && state.selectedDate) || ''),
      wbw_time: safeStr((slot && slot.time_label) || ''),
      wbw_event_id: safeStr(raw.id || raw.gid || (slot && slot.gid) || ''),
    };
  }

  function productBits(wizardRoot, data) {
    data = data || {};
    var root = wizardRoot;
    return {
      wbw_product_id: safeStr(data.productId || (root && root.getAttribute('data-product-id')) || ''),
      wbw_product_handle: safeStr(
        data.productHandle || (root && root.getAttribute('data-product-handle')) || ''
      ),
      wbw_workshop_type: safeStr(root && root.getAttribute('data-workshop-type')),
      wbw_page_url: (typeof location !== 'undefined' && location.href) || '',
    };
  }

  function base(state, wizardRoot, data) {
    state = state || {};
    lastBranch = safeStr(state.branch) || lastBranch;
    return Object.assign(
      {
        wbw_branch: lastBranch,
        wbw_flow: safeStr(state.flow) || 'booking',
      },
      productBits(wizardRoot, data),
      venueBits(state),
      slotBits(state)
    );
  }

  function mark(kind) {
    engaged = true;
    if (kind && Object.prototype.hasOwnProperty.call(had, kind)) had[kind] = true;
  }

  function track(eventName, state, wizardRoot, data, extra) {
    push(eventName, Object.assign(base(state, wizardRoot, data), extra || {}));
  }

  /** mark + track in one call (user actions only). */
  function trackUser(kind, eventName, state, wizardRoot, data, extra) {
    if (kind) mark(kind);
    track(eventName, state, wizardRoot, data, extra);
  }

  function trackStepView(state, wizardRoot, data, branch) {
    var b = safeStr(branch || (state && state.branch) || '');
    if (!b || b === lastStepTracked) return;
    lastStepTracked = b;
    track('wbw_step_view', state, wizardRoot, data, { wbw_step: b });
  }

  function resetFunnel() {
    engaged = false;
    converted = false;
    abandonSent = false;
    had = { venue: false, date: false, time: false, design: false };
    lastStepTracked = '';
  }

  function armAbandon(getStateCtx) {
    if (abandonBound) return;
    abandonBound = true;
    function maybeAbandon(ev) {
      /* bfcache restore — user may come back; don't count as abandon */
      if (ev && ev.persisted) return;
      if (converted || !engaged || abandonSent) return;
      abandonSent = true;
      var ctx = typeof getStateCtx === 'function' ? getStateCtx() || {} : {};
      push(
        'wbw_abandon',
        Object.assign(
          {
            wbw_last_step: lastBranch || safeStr(ctx.wbw_branch) || '',
            wbw_had_venue: had.venue ? '1' : '0',
            wbw_had_date: had.date ? '1' : '0',
            wbw_had_time: had.time ? '1' : '0',
            wbw_had_design: had.design ? '1' : '0',
          },
          ctx
        )
      );
    }
    /* pagehide only — visibilitychange would false-fire on tab switch */
    global.addEventListener('pagehide', maybeAbandon);
  }

  global.WorkshopBookingWizardAnalytics = {
    track: track,
    trackUser: trackUser,
    trackStepView: trackStepView,
    mark: mark,
    markConverted: function () {
      converted = true;
    },
    resetFunnel: resetFunnel,
    wizardViewOnce: function (state, wizardRoot, data) {
      if (viewed) return;
      viewed = true;
      track('wbw_wizard_view', state, wizardRoot, data);
    },
    armAbandon: armAbandon,
  };
})(typeof window !== 'undefined' ? window : this);
